export function getConfig(): AppConfig {
    let smartCaptchaSiteKey = 'ysc1_2vgnQKMfJE4mEeLDigmc4iuOGo71a2Sr3bTphUQqa63bf3da';

    if (process.env.NODE_ENV === 'production') {
        smartCaptchaSiteKey = 'ysc1_gk3LuRhdlgkEPcOtIv665M2hdxE2HdRBzRroNKyhfd624b7d';
    }

    return { SmartCaptchaSiteKey: smartCaptchaSiteKey };
}

// Настройки конфигурации приложения
export interface AppConfig {
    SmartCaptchaSiteKey: string;
}
